const LinkSeparator = () => <span style={{ padding: '0 0.5rem' }}>|</span>

export default LinkSeparator
